<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: LoginModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="login-modal modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Sign in</h5>
          <button
            type="button"
            class="login-modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form autocomplete="on" v-on:submit.prevent>
            <div class="form-group">
              <label for="username">Username</label>
              <input
                v-model="username"
                type="text"
                class="edit-lab-modal__username form-control"
                id="username"
                autocomplete="username"
              />
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input
                v-model="password"
                type="password"
                class="edit-lab-modal__password form-control"
                id="password"
                autocomplete="current-password"
                v-on:keyup.enter="loginRequested"
              />
            </div>
            <!-- <div class="form-group">
              <p class="form-message">{{ message }}</p>
            </div> -->
            <button
              type="button"
              class="login-modal__cancel btn btn-primary"
              data-dismiss="modal"
              @click="closeModal"
            >
              Cancel
            </button>
            <button
              class="login-modal__save-lab btn btn-primary float-right"
              type="submit"
              @click.prevent="loginRequested"
              data-dismiss="modal"
            >
              Sign in
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/lib/api'

export default {
  name: 'LoginModal',
  props: {
    // message: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    loginRequested() {
      this.$emit('login', this.username, this.password)
      this.username = ''
      this.password = ''
    },
    closeModal() {
      // Cancelling and cleaning up
      this.$emit('closeModal')
      this.username = ''
      this.password = ''
    },
  },
  mounted() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~@/styles/globals';
</style>
